import { type UseQueryOptions } from '@tanstack/react-query';
import { useGetOrder } from './useGetOrder';

export function usePollGetOrderNotShuffling(
  params: {
    orderId?: number;
  },
  options?: Pick<UseQueryOptions, 'enabled'>
) {
  const { orderId } = params;

  const getOrderRequest = useGetOrder(orderId, {
    ...options,
    refetchInterval(query) {
      const { data, dataUpdateCount } = query.state;

      if (data?.is_shuffling === false) {
        return false;
      }

      if (dataUpdateCount > 1) {
        return 1000;
      } else {
        return 3000;
      }
    },
  });

  return getOrderRequest;
}
